// deps
import { useEffect } from "react";

// internal-deps
import { getBridgeSdk } from "@swiggy-private/checkout-core";
import { RefreshScreenLinkTypes, RefreshTypes } from "@swiggy-private/native-bridge";

export interface UseRefreshMenuProps {
    isRefreshMenu?: boolean;
    restaurantId?: string;
}

/**
 * Refreshes the native menu screen when the cart response requests a menu refresh.
 */
export const useRefreshMenu = ({ isRefreshMenu, restaurantId }: UseRefreshMenuProps): void => {
    useEffect(() => {
        if (!isRefreshMenu) {
            return;
        }

        getBridgeSdk().refreshScreen({
            type: RefreshTypes.SCREEN,
            link: RefreshScreenLinkTypes.MENU,
            params: {
                restaurantId: restaurantId || "",
            },
        });
    }, [isRefreshMenu, restaurantId]);
};
